import { AbpHttpInterceptor, RefreshTokenService, AbpHttpConfigurationService } from 'abp-ng2-module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import * as ApiServiceProxies from './service-proxies';
import { ZeroRefreshTokenService } from '@account/auth/zero-refresh-token.service';
import { ZeroTemplateHttpConfigurationService } from './zero-template-http-configuration.service';

@NgModule({
    providers: [
        ApiServiceProxies.MaterialsServiceProxy,        
        ApiServiceProxies.PersonnelsServiceProxy,
        ApiServiceProxies.AllocationSheetsServiceProxy,
        ApiServiceProxies.LocationsServiceProxy,
        ApiServiceProxies.ImpactedWorkEventsServiceProxy,
        ApiServiceProxies.WeatherPhenomenasServiceProxy,
        ApiServiceProxies.VarianceFromPlanReasonsServiceProxy,
        ApiServiceProxies.ActivityDaysServiceProxy,
        ApiServiceProxies.ActivitiesServiceProxy,
        ApiServiceProxies.ControllingStructuresServiceProxy,
        ApiServiceProxies.AssetsServiceProxy,
        ApiServiceProxies.PlantsServiceProxy,
        ApiServiceProxies.BiositeStaffDatasServiceProxy,
        ApiServiceProxies.StaffSubordinatesHierarchiesServiceProxy,
        ApiServiceProxies.StaffSubordinatesServiceProxy,
        ApiServiceProxies.StaffsServiceProxy,
        ApiServiceProxies.StaffsAndUsersServiceProxy,
        ApiServiceProxies.ProjectsServiceProxy,
        ApiServiceProxies.BiositeJobRolesServiceProxy,
        ApiServiceProxies.BiositeUserGroupsServiceProxy,
        ApiServiceProxies.BiositeEmployingCompaniesServiceProxy,
        ApiServiceProxies.BiositeLocationsServiceProxy,
        ApiServiceProxies.BiositeOperatingLevelsServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.AlloSettingsServiceProxy,
        ApiServiceProxies.ProjectDataServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.PermissionGroupServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.DemoUiComponentsServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.PayPalPaymentServiceProxy,
        ApiServiceProxies.StripePaymentServiceProxy,
        ApiServiceProxies.DashboardCustomizationServiceProxy,
        ApiServiceProxies.WebhookEventServiceProxy,
        ApiServiceProxies.WebhookSubscriptionServiceProxy,
        ApiServiceProxies.WebhookSendAttemptServiceProxy,
        ApiServiceProxies.UserDelegationServiceProxy,
        ApiServiceProxies.DynamicPropertyServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyDefinitionServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyServiceProxy,
        ApiServiceProxies.DynamicPropertyValueServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyValueServiceProxy,
        ApiServiceProxies.TwitterServiceProxy,
        ApiServiceProxies.AssetsAndControllingStructuresServiceProxy,
        ApiServiceProxies.FormsServiceProxy,
        { provide: RefreshTokenService, useClass: ZeroRefreshTokenService },
        { provide: AbpHttpConfigurationService, useClass: ZeroTemplateHttpConfigurationService },
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
